<template>
  <section class="story-section section-padding bg-gray-100 text-white clear-both" id="story">
    <div class="site-width mx-auto">
      <div class="grid md:grid-cols-2 justify-center items-stretch gap-8">
        <div class="poster-container md:order-1">
          <picture class="poster">
            <img :src="posterImage" alt="Loverboy poster" class="w-full h-full object-cover rounded-lg shadow-lg">
          </picture>
        </div>
        <div class="text-container md:order-2">
          <h1 class="section-heading text-white font-alt">Het verhaal</h1>
          <div class="prose prose-md md:prose-lg text-white">
            <p class="lead">
              De film vertelt het verhaal van Terrance, een alleenstaande vader die wanhopig probeert zijn 9-jarige dochter te beschermen tegen een uithuisplaatsing door de jeugdbescherming. Wanneer hij verstrikt raakt in een torenhoge schuld aan een beruchte mensenhandelaar, wordt hij gedwongen tot een hartverscheurend en gevaarlijk dilemma.
            </p>
            <p>
              Terrance moet zijn schuld afbetalen door drie onschuldige jonge vrouwen seksueel uit te buiten. Lukt het hem niet om binnen de opgelegde tijdslimiet te slagen, dan volgen er meedogenloze consequenties.
            </p>
            <p>
              Het extreem realistische verhaal over mensenhandel en uitbuiting
              dat geïnspireerd is op waargebeurde verhalen is vanaf
              29 augustus te zien in geselecteerde bioscopen. Met
              o.a. Olaf Ait Tami (Meskina), Mohammed Azaay
              (Gouden uur), Skaffa (Rwina!), Cyriel Guds (Mocro
              Maffia, Suriname) en een filmdebuut voor Ayleen Bella
              (Ex on the Beach).
            </p>
          </div>
          <div class="kijkwijzer-icons">
            <img :src="kijkwijzer16" alt="Kijkwijzer 16+" class="kijkwijzer-icon">
            <img :src="kijkwijzerGeweld" alt="Kijkwijzer Geweld" class="kijkwijzer-icon">
            <img :src="kijkwijzerTaal" alt="Kijkwijzer Grof Taalgebruik" class="kijkwijzer-icon">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import posterImage from '/src/assets/sectie3_poster_links.webp'
import kijkwijzer16 from '/src/assets/16.png'
import kijkwijzerGeweld from '/src/assets/geweld.png'
import kijkwijzerTaal from '/src/assets/taal.png'

export default {
  name: 'StorySection',
  data() {
    return {
      posterImage,
      kijkwijzer16,
      kijkwijzerGeweld,
      kijkwijzerTaal,
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'Growly-Grin';
  src: url('@/assets/fonts/Growly-Grin.ttf.woff') format('woff');
  src: url('@/assets/fonts/Growly-Grin.ttf.woff2') format('woff2');
  font-weight: normal;
  font-style: normal;
}

.story-section {
  position: relative;
  padding: 40px 0;
  color: white;
  overflow: hidden;
  background-image: url('@/assets/story_background.jpg');
  background-size: cover;
  background-position: center;
}

.story-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.site-width {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  align-items: stretch;
}

.poster-container, .text-container {
  background: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.poster {
  height: 100%;
  display: flex;
}

.poster img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.section-heading {
  font-family: 'Growly-Grin', sans-serif;
  font-size: 3rem;
  margin-bottom: 1rem;
  text-align: center;
  color: #ffffff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.prose {
  color: white;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.prose p {
  margin-bottom: 1rem;
  line-height: 1.6;
}

.lead {
  font-size: 1.1em;
  font-weight: 600;
}

.kijkwijzer-icons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;
}

.kijkwijzer-icon {
  width: 40px;
  height: 40px;
}

/* Mobile Styles */
@media (max-width: 768px) {
  .story-section {
    padding: 20px 0;
  }

  .grid {
    grid-template-columns: 1fr;
  }

  .section-heading {
    font-size: 2.5rem;
  }

  .poster-container, .text-container {
    padding: 15px;
  }

  .kijkwijzer-icon {
    width: 30px;
    height: 30px;
  }
}
</style>
